const mockUrls = {
  enabled: process.env.VUE_APP_MOCK_ENABLED === 'true',

  list: [
    { url: '/student/pc/freeStudy/courseInfo', method: 'GET' },
    { url: '/student/pc/freeStudy/chapters', method: 'GET' },
    { url: '/student/pc/freeStudy/papers', method: 'GET' },
    { url: '/student/pc/freeStudy/videoProgress', method: 'POST' },
    { url: '/student/pc/freeStudy/wrongQuestions', method: 'GET' },
    { url: '/student/pc/freeStudy/deleteWrong', method: 'POST' },
    { url: '/student/pc/freeStudy/favQuestions', method: 'GET' },
    { url: '/student/pc/freeStudy/deleteFav', method: 'POST' },
    { url: '/student/pc/freeStudy/studyingList', method: 'GET' },
    { url: '/student/pc/freeStudy/allCourseList', method: 'GET' },
    { url: '/student/pc/freeStudy/paperDetail', method: 'GET' },
    { url: '/student/pc/freeStudy/startOrContinue', method: 'POST' },
    { url: '/student/pc/freeStudy/toggleFav', method: 'POST' },
    { url: '/student/pc/freeStudy/saveAnswer', method: 'POST' },
    { url: '/student/pc/freeStudy/submitPaper', method: 'POST' },
    { url: '/student/pc/freeStudy/paperResultSummary', method: 'GET' },
    { url: '/student/pc/freeStudy/paperResultTrend', method: 'GET' },
    { url: '/student/pc/freeStudy/paperRecordList', method: 'GET' },
    { url: '/student/pc/freeStudy/paperRecordDetail', method: 'GET' },
    { url: '/student/pc/freeStudy/deleteRecord', method: 'POST' },
    { url: '/student/pc/freeStudy/startRedo', method: 'POST' },
    { url: '/student/pc/freeStudy/wrongList', method: 'GET' },
    { url: '/student/pc/freeStudy/favList', method: 'GET' }
  ],

  shouldMock(url, method) {
    if (!this.enabled) return false
    return this.list.some(item => 
      item.url === url && 
      item.method.toLowerCase() === (method || 'get').toLowerCase()
    )
  }
}

export default mockUrls
